export default __webpack_public_path__ + "static/media/selfcare_logo.081e50d8.jpeg";